'use client';
import ErrorPage from '~/components/ErrorPage';
import { BasePageData } from '~/types/cosmicModules';
import { IErrorPage } from '~/types/general';
import PageBodyBuilder from '~/ui-modules/PageBodyBuilder';

import { CookieSetter } from './CookieSetter';

type Props = {
  pageData: BasePageData;
  slug: string;
  cookieObj?: object;
} & IErrorPage;

export const ReferralVoucher = ({
  statusCode,
  pageData,
  errorMessage,
  cookieObj,
}: Props) => {
  if (statusCode) {
    return (
      <ErrorPage
        pageData={pageData}
        statusCode={statusCode}
        error={new Error(errorMessage)}
      />
    );
  }

  return (
    <>
      <PageBodyBuilder data={pageData} />
      <CookieSetter cookieObj={cookieObj} withRedirect={false} />
    </>
  );
};
